import React, { useState, useEffect, useRef, Fragment, useMemo } from 'react'
import { connect } from 'react-redux'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import {
  IFText,
  IFFilter,
  IFTextInput,
  IFDialog,
  IFSkeleton,
  IFsvg,
  IFTooltipIconsLoading,
  IFToggle,
  IFToastMessage,
  StationUptimeMonitor,
  IFButtonSkeleton,
} from 'Components'
import {
  ConnectorList,
  ChargePointDetailsTabs,
  ChargePointLogList,
  ChargePointTransactionList,
  ChargePointSpecsContainer,
  ChargerSpecsEdit,
  ConfigurationModal,
  MoveStationModal,
  TerminalModal,
  UploadDiagnosticsModal,
  AlertModal,
  FirmwareModal,
  LocalListModal,
  ChargingProfileModal,
  OperatorUserActionsChargePoint,
} from 'Containers'
import { Colors } from 'Theme'
import Styles from './ChargePointDetails.module.css'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import RequestState from 'Enums/RequestState'
import ChargePointActions from 'Stores/ChargePoint/Actions'
import Scrollbars from 'react-custom-scrollbars-2'
import Icon from '@mui/material/Icon'
import DateRangeIcon from '@mui/icons-material/DateRange'
import moment from 'moment'
import icons from 'Theme/Icons'
import styled from 'styled-components'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import OCPPServices from '../../Services/OCPPService'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import InfoIcon from '@mui/icons-material/Info'
import StationActions from 'Stores/Station/Actions'
import StationSelectors from 'Stores/Station/Selectors'
import InfinityEnums from 'Enums/InfinityEnums'
import AuthSelectors from 'Stores/Auth/Selectors'
import Fade from '@mui/material/Fade'
import { mapStatus, mapType } from 'Utils/ConnectorFunctions'
import { increaseBrightness } from '../../Utils/Calculations'
import { VisibilityOff, VisibilityRounded } from '@mui/icons-material'
import { NoInternet } from 'Components/IFEmptyStates/IFEmptyStates'
import { toaster } from 'rsuite'
import ConnectorUtilization from 'Components/ConnectorUtilization/ConnectorUtilization'
import OperatorUserActionsAction from 'Stores/OperatorUserActions/Actions'
import OperatorUserActionsSelectors from 'Stores/OperatorUserActions/Selectors'
import { getDefaultChargePointStatisticsFilter } from 'Constants/Filters'
import { generateQRPDF } from 'Utils/generateQR'

const { ConnectorPowerLevel } = InfinityEnums
const DividerDivHorizontal = styled.div`
  border-top: 1px solid ${Colors.DividerColor};
`

const LeftContainer = styled.div`
  border-right: ${(props) =>
    props.canEdit ? `1px solid ${Colors.DividerColor}` : ''};
`
const weekToSecs = 604800

const handleChargingIcon = (maxPower) => {
  if (maxPower <= ConnectorPowerLevel.LEVEL1)
    return (
      <img className={Styles.ChargingIcon} src={icons.normalCharging} alt="" />
    )
  else if (maxPower <= ConnectorPowerLevel.LEVEL2)
    return (
      <img className={Styles.ChargingIcon} src={icons.fastCharging} alt="" />
    )
  else
    return (
      <img className={Styles.ChargingIcon} src={icons.superCharging} alt="" />
    )
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: Colors.white,
    boxShadow: `0px 0px 4px 0px ${Colors.tooltipBoxShadow}`,
    maxWidth: 'none',
  },
}))

const StyledTooltipToggle = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `${Colors.primary} !important`,
    color: `${Colors.white} !important`,
    fontSize: '0.75rem !important',
    fontFamily: 'ProximaNova !important',
    padding: '0.3rem !important',
    marginRight: '0.5rem !important',
  },
}))

const ChargePointDetails = ({
  chargePoint,
  chargePointName,
  chargePointConnectors,
  maxPower,
  fetchChargePointConfigList,
  chargePointLogFilter,
  fetchChargePointLogList,
  chargePointTransactionFilter,
  fetchChargePointTransactionList,
  setChargePointLogsFilter,
  setChargePointTransactionsFilter,
  clearChargePointLogs,
  clearChargePointTransactions,
  updateChargePoint,
  updateChargePointRequestState,
  selectedIndex,
  deleteChargePoint,
  deleteChargePointRequestState,
  fetchChargePointListRequestState,
  fetchStationMoveList,
  moveStationsFilter,
  fetchStationListRequestState,
  moveChargePointRequestState,
  setChargePointLogPaginationOffset,
  setChargePointTransactionPaginationOffset,
  editChargePoints,
  clearMoveStations,
  setMoveStationPaginationOffset,
  stationSelectedIndex,
  fetchChargePointLogListRequestState,
  fetchChargePointTransactionListRequestState,
  operatorUser,
  operator,
  chargePointLogs,
  chargePointTransactions,
  resetChargePointRequestState,
  activateChargePoint,
  resetChargePointState,
  fetchChargePointRequestState,
  clearChargePointCacheRequestState,
  chargePoints,
  resetFilters,
  changeChargePointAvailabilityRequestState,
  selectedStation,
  scrollStationListToIndex,
  fetchChargePoint,
  fetchChargePointList,
  deleteChargePointTariffsRequestState,
  addChargePointTariffsRequestState,
  addChargePointAccessGroupsBulkRequestState,
  deleteChargePointAccessGroupsBulkRequestState,
  deleteChargePointPrivacyRulesRequestState,
  addChargePointPrivacyRulesRequestState,
  chargePointUid,
  isChargePointLogsLive,
  setIsChargePointLogsLive,
  chargePointPrivacy,
  chargePointAppVisibility,
  chargePointUptimeData,
  fetchChargePointUptimeStatistics,
  fetchChargePointUptimeStatisticsRequestState,
  chargePointStatisticsFilter,
  setChargePointStatisticsFilter,
  connectorsUtilizationData,
  fetchConnectorsUtilization,
  fetchConnectorsUtilizationRequestState,
  fetchChargePointSubscribedAlerts,
  fetchChargePointAlerts,
  fetchChargePointLocalList,
  fetchChargePointCompositeSchedule,
  fetchConnectorTypes,
  fetchOperatorUserActionsChargePoint,
  operatorUserActionsFilters,
  resetOperatorUserActionsChargePoint,
  fetchOperatorUserActionsChargePointRequestState,
  setOperatorUserActionsPaginationOffset,
  setOperatorUserActionsFilters,
  operatorUserActionsChargePoint,
  clearOperatorUserActionsFilters,
  blockChargePoint,
}) => {
  const { t } = useTranslation()
  const confirmDeleteDialog = useRef()
  const resetDialog = useRef()
  const moveStationRef = useRef()
  const configurationRef = useRef()
  const chargePointDetailsTabsRef = useRef()
  const firmwareRef = useRef()
  const uploadDiagnosticsRef = useRef()
  const connectorListRef = useRef()
  const appToggleRef = useRef()
  const chargePointPrivacyRef = useRef()
  const chargePointBlockRef = useRef()
  const terminalRef = useRef()
  const localListRef = useRef()
  const alertModalRef = useRef()
  const ProfileModalRef = useRef()
  const transactionRef = useRef()
  const logRef = useRef()

  const handleDownloadPDF = async () => {
    if (!selectedStation?.chargePoints?.length) return
    const currentChargePoint = selectedStation.chargePoints.find(
      (cp) => cp.name === chargePointName,
    )
    if (!currentChargePoint) return
    for (const evse of currentChargePoint.evses || []) {
      for (const connector of evse.connectors || []) {
        if (!connector?.uid || connector.uid === 0) continue
        await generateQRPDF({
          siteName: selectedStation.name,
          cpName: chargePointName,
          connectorUid: connector.uid,
          stationId: currentChargePoint._id,
          connectorId: connector.uid,
        })
        await new Promise((resolve) => setTimeout(resolve, 300))
      }
    }
  }
  const toolTipTitles = [
    {
      title: t('ChargePointDetails.SerialNumber'),
      detail: chargePoint?.serial ? chargePoint?.serial : '—',
    },
    {
      title: t('ChargePointDetails.Model'),
      detail: chargePoint?.model ? chargePoint?.model : '—',
    },
    {
      title: t('ChargePointDetails.Vendor'),
      detail: chargePoint?.vendor ? chargePoint?.vendor : '—',
    },
    {
      title: t('ChargePointDetails.FirmwareVersion'),
      detail: chargePoint?.firmwareVersion ? chargePoint?.firmwareVersion : '—',
    },
    {
      title: t('ChargePointDetails.OCPPVersion'),
      detail: chargePoint?.ocppVersion ? chargePoint?.ocppVersion : '—',
    },
    {
      title: t('ChargePointDetails.IMSI'),
      detail: chargePoint?.imsi ? chargePoint?.imsi : '—',
    },
    {
      title: t('ChargePointDetails.ICCID'),
      detail: chargePoint?.iccid ? chargePoint?.iccid : '—',
    },
  ]

  const [isEdit, setIsEdit] = useState(false)
  const [newChargePoint, setNewChargePoint] = useState({})
  const [selectedDetails, setSelectedDetails] = useState(0)
  const [title, setTitle] = useState(chargePointName ? chargePointName : '')
  const [isConnecting, setIsConnecting] = useState(
    chargePoint
      ? !chargePoint.isActivated &&
          chargePoint.evses?.flatMap((evse) => evse.connectors || []).length ===
            0
      : false,
  )
  const connectorEdits = useRef(
    chargePoint
      ? chargePoint.evses
          ?.flatMap((evse) => evse.connectors || [])
          .map((conn) => ({
            _id: conn._id,
            uid: conn.uid,
            type: '',
            maxPower: -1,
            currentType: '',
            powerType: '',
            tariff: null,
            isRemoved: null,
            socLimit: undefined,
          }))
      : [],
  )
  const [logListLastUpdated, setLogListLastUpdated] = useState(null)
  const [transactionListLastUpdated, setTransactionListLastUpdated] =
    useState(null)
  const [cpUptimeLastUpdated, setCpUpTimeLastUpdated] = useState(null)
  const [operatorUserActionsLastUpdated, setOperatorUserActionsLastUpdated] =
    useState(null)
  const [refreshingLogs, setRefreshingLogs] = useState(false)
  const [isFiltersSelected, setIsFiltersSelected] = useState(false)
  const [ascendingLogs, setAscendingLogs] = useState(false)
  const [ascendingTransactions, setAscendingTransactions] = useState(false)
  const [toggleValueChanged, setToggleValueChanged] = useState(false)
  const [isPrivate, setIsPrivate] = useState(chargePoint?.isPrivate)
  const [fetchConnectorTypesFlag, setFetchConnectorsTypesFlag] = useState(false)
  let [uptimeGraphStartTimestamp, setUptimeGraphStartTimestamp] = useState(null)
  let [connectorGraphStartTimestamp, setConnectorGraphStartTimestamp] =
    useState(null)
  let [monitorIsLoadingFlag, setMonitorIsLoadingFlag] = useState(true)
  const canViewUptimeStats = operatorUser.permissions.includes(
    InfinityEnums.OperatorUserPermission.CAN_VIEW_CHARGEPOINT_UPTIME,
  )
  const [isBlocked, setIsBlocked] = useState(chargePoint?.isBlocked)

  useEffect(() => {
    resetFilters()
    clearOperatorUserActionsFilters()
    resetOperatorUserActionsChargePoint()
    clearChargePointLogs()
    setChargePointLogPaginationOffset(0)
    clearChargePointTransactions()
    setChargePointTransactionPaginationOffset(0)
    logRef?.current?.clearFilter()
    transactionRef?.current?.clearFilter()
  }, [stationSelectedIndex, selectedIndex])

  const handleChargePointConnectorsUpdates = () => {
    connectorEdits.current = []

    chargePointConnectors.forEach((connector) => {
      const connectorFound = connectorEdits.current.find(
        (connectorEdit) => connectorEdit._id === connector._id,
      )
      if (!connectorFound) {
        connectorEdits.current.push({
          _id: connector._id,
          uid: connector.uid,
          type: '',
          maxPower: -1,
          currentType: '',
          powerType: '',
          tariff: null,
          isRemoved: null,
          socLimit: undefined,
        })
      }
    })
  }
  useEffect(() => {
    if (
      fetchChargePointUptimeStatisticsRequestState === RequestState.SUCCEEDED &&
      fetchConnectorsUtilizationRequestState === RequestState.SUCCEEDED
    ) {
      if (
        chargePointUptimeData.graphStartTimestamp !== 0 &&
        connectorsUtilizationData.graphStartTimestamp !== 0
      ) {
        if (
          chargePointUptimeData.graphStartTimestamp !=
          connectorsUtilizationData.graphStartTimestamp
        ) {
          if (
            chargePointUptimeData.graphStartTimestamp <
            connectorsUtilizationData.graphStartTimestamp
          ) {
            setUptimeGraphStartTimestamp(
              chargePointUptimeData.graphStartTimestamp,
            )
            setConnectorGraphStartTimestamp(
              chargePointUptimeData.graphStartTimestamp,
            )
          } else {
            setUptimeGraphStartTimestamp(
              connectorsUtilizationData.graphStartTimestamp,
            )
            setConnectorGraphStartTimestamp(
              connectorsUtilizationData.graphStartTimestamp,
            )
          }
        } else {
          setUptimeGraphStartTimestamp(
            chargePointUptimeData.graphStartTimestamp,
          )
          setConnectorGraphStartTimestamp(
            chargePointUptimeData.graphStartTimestamp,
          )
        }
      } else {
        setUptimeGraphStartTimestamp(chargePointUptimeData.graphStartTimestamp)
        setConnectorGraphStartTimestamp(
          connectorsUtilizationData.graphStartTimestamp,
        )
      }
      setMonitorIsLoadingFlag(false)
    }
  }, [
    fetchChargePointUptimeStatisticsRequestState,
    fetchConnectorsUtilizationRequestState,
  ])

  useEffect(() => {
    if (chargePoint) {
      let chargePointConnectorsLength = chargePoint.evses?.flatMap(
        (evse) => evse.connectors || [],
      ).length
      setIsConnecting(
        !chargePoint.isActivated && chargePointConnectorsLength === 0,
      )
      if (
        !chargePoint.isActivated &&
        chargePointConnectorsLength !== connectorEdits.current.length
      ) {
        handleChargePointConnectorsUpdates()
      }
    }
  }, [chargePointConnectors])

  useEffect(() => {
    setTitle(chargePointName ? chargePointName : '')
  }, [chargePointName])

  useEffect(() => {
    chargePointPrivacyRef.current?.setValue(!chargePointPrivacy)
  }, [chargePointPrivacy])
  useEffect(() => {
    chargePointBlockRef.current?.setValue(!chargePoint?.isBlocked)
  }, [chargePoint])
  useEffect(() => {
    handleChargePointConnectorsUpdates()

    setTitle(chargePoint ? chargePoint.name : '')
    if (
      chargePoint &&
      connectorListRef &&
      connectorListRef.current &&
      connectorListRef.current !== null
    ) {
      connectorListRef.current.resetMaxPowerValues()
      connectorListRef.current.closeAccordions()
      connectorListRef.current.resetStatusValue()
      connectorListRef.current.resetVisibilityValue()
      connectorListRef.current.resetSocLimitValues()
    }

    if (chargePointDetailsTabsRef.current) {
      chargePointDetailsTabsRef.current.resetIndex()
      setSelectedDetails(0)
    }
    setChargePointLogPaginationOffset(0)
    clearChargePointLogs()
    clearChargePointTransactions()
    if (chargePoint) {
      fetchChargePointLogList(
        chargePointLogFilter,
        0,
        chargePoint._id,
        ascendingLogs,
      )
      const updatedFilterConnectors = [...chargePointTransactionFilter]
      updatedFilterConnectors.forEach((filter) => {
        if (filter.field === 'connector') {
          const connectorsUid = chargePoint.evses
            ?.flatMap((evse) => evse.connectors || [])
            .filter((connector) => connector.uid !== 0)
            .map((connector) => connector.uid)
          filter.data = connectorsUid
        }
      })
      setChargePointTransactionsFilter(updatedFilterConnectors)
    }
    setLogListLastUpdated(null)
    setTransactionListLastUpdated(null)
    setCpUpTimeLastUpdated(null)
    setOperatorUserActionsLastUpdated(null)
    setIsFiltersSelected(false)
    resetFilters()
    clearOperatorUserActionsFilters()
    resetOperatorUserActionsChargePoint()
    setAscendingLogs(false)
    setAscendingTransactions(false)
    setUptimeGraphStartTimestamp(null)
    setConnectorGraphStartTimestamp(null)
    setMonitorIsLoadingFlag(true)
  }, [chargePointUid])

  useEffect(() => {
    if (chargePoint && selectedDetails === 0) {
      resetFilters()
      clearOperatorUserActionsFilters()
      resetOperatorUserActionsChargePoint()
      clearChargePointLogs()
      setChargePointLogPaginationOffset(0)
      fetchChargePointLogList(
        chargePointLogFilter,
        0,
        chargePoint._id,
        ascendingLogs,
      )
      logRef?.current?.clearFilter()
      resetOperatorUserActionsChargePoint()
    } else if (chargePoint && selectedDetails === 1) {
      resetFilters()
      clearOperatorUserActionsFilters()
      resetOperatorUserActionsChargePoint()
      clearChargePointTransactions()
      setChargePointTransactionPaginationOffset(0)
      fetchChargePointTransactionList(
        chargePointTransactionFilter,
        0,
        chargePoint._id,
        ascendingTransactions,
      )
      transactionRef?.current?.clearFilter()
      resetOperatorUserActionsChargePoint()
    } else if (chargePoint && selectedDetails === 2 && canViewUptimeStats) {
      resetFilters()
      clearOperatorUserActionsFilters()
      resetOperatorUserActionsChargePoint()
      fetchChargePointUptimeStatistics(
        chargePoint._id,
        chargePointStatisticsFilter,
      )
      resetOperatorUserActionsChargePoint()

      fetchConnectorsUtilization(chargePoint._id, chargePointStatisticsFilter)
    }
  }, [selectedDetails])

  useEffect(() => {
    if (updateChargePointRequestState === RequestState.SUCCEEDED) {
      editChargePoints(selectedIndex, newChargePoint)
    }
    if (
      (updateChargePointRequestState === RequestState.SUCCEEDED ||
        moveChargePointRequestState === RequestState.SUCCEEDED ||
        changeChargePointAvailabilityRequestState === RequestState.SUCCEEDED ||
        deleteChargePointTariffsRequestState === RequestState.SUCCEEDED ||
        addChargePointTariffsRequestState === RequestState.SUCCEEDED ||
        addChargePointAccessGroupsBulkRequestState === RequestState.SUCCEEDED ||
        deleteChargePointAccessGroupsBulkRequestState ===
          RequestState.SUCCEEDED ||
        deleteChargePointPrivacyRulesRequestState === RequestState.SUCCEEDED ||
        addChargePointPrivacyRulesRequestState === RequestState.SUCCEEDED) &&
      updateChargePointRequestState !== RequestState.LOADING &&
      moveChargePointRequestState !== RequestState.LOADING &&
      changeChargePointAvailabilityRequestState !== RequestState.LOADING &&
      deleteChargePointTariffsRequestState !== RequestState.LOADING &&
      addChargePointTariffsRequestState !== RequestState.LOADING &&
      addChargePointAccessGroupsBulkRequestState !== RequestState.LOADING &&
      deleteChargePointAccessGroupsBulkRequestState !== RequestState.LOADING &&
      deleteChargePointPrivacyRulesRequestState !== RequestState.LOADING &&
      addChargePointPrivacyRulesRequestState !== RequestState.LOADING
    ) {
      let toasterMessage = ''
      if (newChargePoint.activate && !newChargePoint.preActivate) {
        toasterMessage = t('ToasterMessages.StationActivated')
      } else {
        toasterMessage = t('ToasterMessages.StationUpdated')
        resetChargePointState()
      }
      if (toasterMessage.length > 0) {
        toaster.push(<IFToastMessage type="success" text={toasterMessage} />, {
          placement: 'topEnd',
        })
      }
      setNewChargePoint({})
      setIsEdit(false)
    }
  }, [
    updateChargePointRequestState,
    moveChargePointRequestState,
    changeChargePointAvailabilityRequestState,
    deleteChargePointTariffsRequestState,
    addChargePointTariffsRequestState,
    addChargePointAccessGroupsBulkRequestState,
    deleteChargePointAccessGroupsBulkRequestState,
    deleteChargePointPrivacyRulesRequestState,
    addChargePointPrivacyRulesRequestState,
  ])

  useEffect(() => {
    if (deleteChargePointRequestState === RequestState.SUCCEEDED) {
      if (confirmDeleteDialog.current) confirmDeleteDialog.current.dismiss()
      resetChargePointState()
      setIsEdit(false)
    }
  }, [deleteChargePointRequestState])

  useEffect(() => {
    if (chargePoint) {
      setChargePointLogPaginationOffset(0)
      fetchChargePointLogList(
        chargePointLogFilter,
        0,
        chargePoint._id,
        ascendingLogs,
      )
    }
  }, [chargePointLogFilter])

  useEffect(() => {
    if (chargePoint) {
      setChargePointTransactionPaginationOffset(0)
      fetchChargePointTransactionList(
        chargePointTransactionFilter,
        0,
        chargePoint._id,
        ascendingTransactions,
      )
    }
  }, [chargePointTransactionFilter])

  useEffect(() => {
    if (
      !(
        resetChargePointRequestState === RequestState.UNINITIALIZED ||
        resetChargePointRequestState === RequestState.LOADING
      ) &&
      resetDialog
    ) {
      resetDialog.current.dismiss()
    }
  }, [resetChargePointRequestState])
  useEffect(() => {
    if (
      fetchChargePointLogListRequestState !== RequestState.LOADING &&
      fetchChargePointLogListRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setLogListLastUpdated(Date.now())
    }
  }, [fetchChargePointLogListRequestState])

  useEffect(() => {
    if (
      fetchChargePointUptimeStatisticsRequestState !== RequestState.LOADING &&
      fetchChargePointUptimeStatisticsRequestState !==
        RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setCpUpTimeLastUpdated(Date.now())
    }
  }, [fetchChargePointUptimeStatisticsRequestState])

  useEffect(() => {
    if (
      fetchConnectorsUtilizationRequestState !== RequestState.LOADING &&
      fetchConnectorsUtilizationRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setCpUpTimeLastUpdated(Date.now())
    }
  }, [fetchConnectorsUtilizationRequestState])

  useEffect(() => {
    if (
      fetchChargePointTransactionListRequestState !== RequestState.LOADING &&
      fetchChargePointTransactionListRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setTransactionListLastUpdated(Date.now())
    }
  }, [fetchChargePointTransactionListRequestState])

  useEffect(() => {
    if (
      fetchOperatorUserActionsChargePointRequestState !==
        RequestState.LOADING &&
      fetchOperatorUserActionsChargePointRequestState !==
        RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setOperatorUserActionsLastUpdated(Date.now())
    }
  }, [fetchOperatorUserActionsChargePointRequestState])

  useEffect(() => {
    setIsEdit(false)
  }, [selectedIndex, selectedStation])

  const handleSelectedTab = (index) => {
    setIsFiltersSelected(false)
    setSelectedDetails(index)
  }
  const handleChargePointLogs = (newFilter) => {
    clearChargePointLogs()
    const adjustedFilter = newFilter.map((filter) => {
      if (filter.value) filter.initialValue = filter.value
      return filter
    })
    setChargePointLogsFilter(adjustedFilter)
  }
  const handleChargePointTransactions = (newFilter) => {
    clearChargePointTransactions()
    const adjustedFilter = newFilter.map((filter) => {
      if (filter.value) filter.initialValue = filter.value
      return filter
    })
    setChargePointTransactionsFilter(adjustedFilter)
  }
  const handleConfigurationOpen = () => {
    configurationRef.current.show()
    fetchChargePointConfigList(chargePoint._id)
  }

  const handleAlertModalOpen = () => {
    alertModalRef.current.show()
    fetchChargePointSubscribedAlerts(chargePoint._id)
    fetchChargePointAlerts(chargePoint._id)
  }

  const handleMaxPowerChange = (value, id) => {
    let connector = connectorEdits.current.find((connector) => {
      return id === connector._id
    })
    connector.maxPower = value
  }

  const handleStatusChange = (value, id) => {
    let updatedList = connectorEdits.current.map((connector) => {
      if (id === connector._id) {
        return { ...connector, status: value }
      }
      return connector
    })

    connectorEdits.current = updatedList
  }

  const handleTariffChange = (value, id) => {
    let connector = connectorEdits.current.find((connector) => {
      return id === connector._id
    })
    connector.tariff = [value]
  }

  const handleTypeChange = (value, id) => {
    let connector = connectorEdits.current.find((connector) => {
      return id === connector._id
    })
    connector.type = mapType(value.type)
    connector.currentType = value.currentType
    if (connector.currentType === InfinityEnums.CurrentType.DC) {
      connector.powerType = InfinityEnums.PowerType.DC
    } else connector.powerType = InfinityEnums.PowerType.AC_3_PHASE
  }

  const handleVisibleChange = (value, id) => {
    let connector = connectorEdits.current.find((connector) => {
      return id === connector._id
    })

    if (connector) connector.isRemoved = !value
  }

  const handleSocLimitChange = (value, id) => {
    let connector = connectorEdits.current.find((connector) => {
      return id === connector._id
    })
    if (connector) connector.socLimit = value === '' ? null : Number(value)
  }

  const handleCancel = () => {
    setIsEdit(false)
    connectorEdits.current =
      chargePoint.evses
        ?.flatMap((evse) => evse.connectors || [])
        .map((conn) => ({
          _id: conn._id,
          uid: conn.uid,
          type: '',
          maxPower: -1,
          currentType: '',
          powerType: '',
          tariff: null,
          isRemoved: null,
          socLimit: undefined,
        })) || []

    setTitle(chargePoint.name)
    connectorListRef.current.resetMaxPowerValues()
    connectorListRef.current.closeAccordions()
    connectorListRef.current.resetStatusValue()
    connectorListRef.current.resetVisibilityValue()
    connectorListRef.current.resetSocLimitValues()

    if (
      chargePoint &&
      chargePointPrivacyRef.current.getValue &&
      chargePoint.isPrivate === chargePointPrivacyRef.current.getValue()
    )
      chargePointPrivacyRef.current.toggleValue()
    const isBlocked = chargePoint?.isBlocked ?? false
    if (
      chargePoint &&
      chargePointBlockRef.current?.getValue &&
      isBlocked === chargePointBlockRef.current.getValue()
    )
      chargePointBlockRef.current.toggleValue()
  }

  const changeAvailability = (connectorStatus) => {
    OCPPServices.changeAvailability(chargePoint._id, connectorStatus, () => {})
  }

  const handleSubmit = (activate) => {
    let chargePointConnectors =
      chargePoint.evses?.flatMap((evse) =>
        (evse.connectors || []).map((connector) => ({
          ...connector,
          isRemoved: evse.isRemoved,
        })),
      ) || []
    let newChargePoint = {}
    let connectors = []
    let connectorFlag = 0
    let connectorStatus = []

    if (title !== chargePoint.name) {
      newChargePoint.name = title
    }

    let reversedPrivacy = false
    if (
      chargePointPrivacyRef.current &&
      chargePointPrivacyRef.current.getValue
    ) {
      reversedPrivacy = !chargePointPrivacyRef.current.getValue()
      if (reversedPrivacy !== chargePoint.isPrivate)
        newChargePoint.isPrivate = reversedPrivacy
    }
    let reversedBlock = false
    if (chargePointBlockRef.current && chargePointBlockRef.current.getValue) {
      reversedBlock = !chargePointBlockRef.current.getValue()
      if (reversedBlock !== chargePoint?.isBlocked) {
        blockChargePoint(chargePoint._id)
      }
    }

    connectorEdits.current.map((connector) => {
      const connectorObj = chargePointConnectors.find(
        (conn) => conn._id === connector._id,
      )
      const tariffChanged =
        connector.tariff &&
        connector.tariff?.[0]?._id !== connectorObj?.tariffIds?.[0]?._id

      const isRemovedProp =
        connector.hasOwnProperty('isRemoved') &&
        connector.isRemoved !== null &&
        connectorObj.isRemoved !== connector.isRemoved
          ? { isRemoved: connector.isRemoved }
          : {}

      const socLimitChanged = connector.socLimit !== undefined

      if (connector.maxPower > 0 && connector.type !== '') {
        connectorFlag = 1
        connectors.push({
          ...connectorObj,
          maxPower: Number(connector.maxPower),
          type: connector.type,
          currentType: connector.currentType,
          powerType: connector.powerType,
          ...(tariffChanged && { tariffIds: connector.tariff }),
          ...(socLimitChanged && { socLimit: connector.socLimit }),
          ...isRemovedProp,
        })
      } else if (connector.maxPower > 0) {
        connectorFlag = 1
        connectors.push({
          ...connectorObj,
          maxPower: Number(connector.maxPower),
          ...(tariffChanged && { tariffIds: connector.tariff }),
          ...(socLimitChanged && { socLimit: connector.socLimit }),
          ...isRemovedProp,
        })
      } else if (connector.type !== '') {
        connectorFlag = 1
        connectors.push({
          ...connectorObj,
          type: connector.type,
          currentType: connector.currentType,
          powerType: connector.powerType,
          ...(tariffChanged && { tariffIds: connector.tariff }),
          ...(socLimitChanged && { socLimit: connector.socLimit }),
          ...isRemovedProp,
        })
      } else if (tariffChanged) {
        connectorFlag = 1
        connectors.push({
          ...connectorObj,
          tariffIds: connector.tariff,
          ...(socLimitChanged && { socLimit: connector.socLimit }),
          ...isRemovedProp,
        })
      } else if (socLimitChanged) {
        connectorFlag = 1
        connectors.push({
          ...connectorObj,
          socLimit: connector.socLimit,
          ...isRemovedProp,
        })
      } else if (isRemovedProp && Object.keys(isRemovedProp).length > 0) {
        connectorFlag = 1
        connectors.push({
          ...connectorObj,
          ...isRemovedProp,
        })
      } else {
        connectors.push({
          ...connectorObj,
        })
      }
      if (connector.status) {
        const mappedStatus = mapStatus(connectorObj.status).text
        if (mappedStatus !== connector.status)
          connectorStatus.push({
            id: connector.uid,
            status: connector.status === 'Available' ? true : false,
          })
      }
    })

    if (activate) {
      newChargePoint.activate = true
    }
    if (connectorFlag) newChargePoint.connectors = connectors

    if (
      newChargePoint.name ||
      newChargePoint.connectors ||
      newChargePoint.activate ||
      newChargePoint.hasOwnProperty('isPrivate')
    ) {
      updateChargePoint(selectedIndex, newChargePoint, () => {
        if (connectorStatus.length !== 0) {
          changeAvailability(connectorStatus)
        }
      })
      if (newChargePoint.activate) {
        activateChargePoint(selectedIndex)
        newChargePoint.preActivate = chargePoint.isActivated
      }
      setNewChargePoint(newChargePoint)
    } else if (connectorStatus.length !== 0) {
      if (connectorStatus.length !== 0) {
        changeAvailability(connectorStatus)
      }
    } else setIsEdit(false)
  }

  const handleSubmitRef = useRef(handleSubmit)

  useEffect(() => {
    handleSubmitRef.current = handleSubmit
  })

  useEffect(() => {
    if (chargePoint && canViewUptimeStats) {
      setMonitorIsLoadingFlag(true)
      fetchChargePointUptimeStatistics(
        chargePoint._id,
        chargePointStatisticsFilter,
      )
      fetchConnectorsUtilization(chargePoint._id, chargePointStatisticsFilter)
    }
  }, [chargePointStatisticsFilter, canViewUptimeStats])

  const handleMoveModal = () => {
    clearMoveStations()
    setMoveStationPaginationOffset(0)
    moveStationRef.current.show()
    fetchStationMoveList(moveStationsFilter, 0)
  }

  const userResetPermissionsText = () => {
    return operatorUser.permissions.includes(
      InfinityEnums.OperatorUserPermission.CAN_SOFT_RESET_CHARGEPOINT,
    ) &&
      operatorUser.permissions.includes(
        InfinityEnums.OperatorUserPermission.CAN_HARD_RESET_CHARGEPOINT,
      )
      ? t('ChargePointDetails.BothResetDialogSubtitle')
      : operatorUser.permissions.includes(
          InfinityEnums.OperatorUserPermission.CAN_SOFT_RESET_CHARGEPOINT,
        )
      ? t('ChargePointDetails.SoftResetDialogSubtitle')
      : operatorUser.permissions.includes(
          InfinityEnums.OperatorUserPermission.CAN_HARD_RESET_CHARGEPOINT,
        )
      ? t('ChargePointDetails.HardResetDialogSubtitle')
      : ''
  }

  const toolTipTitle = (title, details, index) => {
    return (
      <div
        key={`toolTipTitle ${index}`}
        className={
          index === 0 ? Styles.ToolTipContainerFirst : Styles.ToolTipContainer
        }
      >
        <div className={Styles.LeftToolTipDetails}>
          <IFText
            style={{ color: Colors.text }}
            className={Styles.ToolTipTitle}
          >
            {title}
          </IFText>
        </div>
        <div className={Styles.RightToolTipDetails}>
          <IFText
            style={{ color: Colors.tooltipText }}
            className={Styles.ToolTipDetail}
          >
            {details}
          </IFText>
        </div>
      </div>
    )
  }
  const checkFilterEmpty = (newFilter) => {
    const emptyFlag = !newFilter.some((filter) => filter.value.length !== 0)
    if (emptyFlag) return true
    else return false
  }

  const permissionArray = [
    InfinityEnums.OperatorUserPermission.CAN_VIEW_CONFIGURATION,
    InfinityEnums.OperatorUserPermission.CAN_VIEW_DIAGNOSTICS,
    InfinityEnums.OperatorUserPermission.CAN_VIEW_FIRMWARE,
    InfinityEnums.OperatorUserPermission.CAN_USE_TERMINAL,
    InfinityEnums.OperatorUserPermission.CAN_CLEAR_CACHE,
    InfinityEnums.OperatorUserPermission.CAN_HARD_RESET_CHARGEPOINT,
    InfinityEnums.OperatorUserPermission.CAN_SOFT_RESET_CHARGEPOINT,
    InfinityEnums.OperatorUserPermission.CAN_EDIT_CHARGEPOINT,
  ]

  const canEdit = chargePoint
    ? !isConnecting && !chargePoint.isActivated
      ? operatorUser.permissions.includes(
          InfinityEnums.OperatorUserPermission.CAN_EDIT_CHARGEPOINT,
        )
      : permissionArray.some((permission) =>
          operatorUser.permissions.includes(permission),
        )
    : true

  const calculateConnectorUtilizationGraphHeight = (numConnectors) => {
    if (isNaN(numConnectors)) return '250px'
    return `${numConnectors * 36 + 90}px`
  }
  return (
    <Fragment>
      {fetchChargePointRequestState === RequestState.ERROR_0_NETWORK ||
      (fetchChargePointListRequestState === RequestState.ERROR_0_NETWORK &&
        selectedIndex === 0) ? (
        <div style={{ flexGrow: 1 }}>
          <NoInternet
            onClick={() => {
              if (chargePoints.length === 0) {
                fetchChargePointList(selectedStation._id)
              } else {
                fetchChargePoint(chargePoints[selectedIndex]._id)
              }
            }}
          />
        </div>
      ) : (
        <div
          className={Styles.Container}
          style={
            isEdit &&
            (updateChargePointRequestState === RequestState.LOADING ||
              changeChargePointAvailabilityRequestState ===
                RequestState.LOADING ||
              deleteChargePointTariffsRequestState === RequestState.LOADING ||
              addChargePointTariffsRequestState === RequestState.LOADING ||
              addChargePointAccessGroupsBulkRequestState ===
                RequestState.LOADING ||
              deleteChargePointAccessGroupsBulkRequestState ===
                RequestState.LOADING ||
              deleteChargePointPrivacyRulesRequestState ===
                RequestState.LOADING ||
              addChargePointPrivacyRulesRequestState === RequestState.LOADING)
              ? { pointerEvents: 'none' }
              : {}
          }
        >
          <LeftContainer
            className={Styles.LeftContainer}
            canEdit={canEdit}
            style={canEdit ? {} : { marginRight: '0rem' }}
          >
            <div className={Styles.TitleContainer}>
              {fetchChargePointListRequestState === RequestState.LOADING ||
              fetchChargePointRequestState === RequestState.LOADING ||
              fetchStationListRequestState === RequestState.LOADING ? (
                <IFSkeleton
                  style={{ marginTop: '-8px' }}
                  variant="text"
                  width="14rem"
                  height=" 3rem"
                />
              ) : isEdit ||
                (chargePoint &&
                  !chargePoint.isActivated &&
                  !isConnecting &&
                  operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_EDIT_CHARGEPOINT,
                  )) ? (
                <div className={Styles.NameAndToggleContainer}>
                  <div className={Styles.ChargePointNameContainer}>
                    <div className={Styles.ChargePointNameWrapper}>
                      <div
                        className={Styles.ChargePointStationNameContainer}
                        onClick={() => {
                          scrollStationListToIndex(stationSelectedIndex)
                        }}
                        style={{
                          backgroundColor: increaseBrightness(
                            Colors.primary,
                            10,
                          ),
                        }}
                      >
                        <IFText
                          style={{ color: Colors.white }}
                          className={Styles.NameText}
                        >
                          {selectedStation ? selectedStation.name : ''}
                        </IFText>
                      </div>
                      <div
                        className={`${Styles.ChargePointName} ${Styles.ChargePointNameEdit}`}
                        style={{
                          border: `1.5px solid ${increaseBrightness(
                            Colors.primary,
                            10,
                          )}`,
                        }}
                      >
                        <IFTextInput
                          className={Styles.TextInputStyle}
                          value={title}
                          fontSize={20}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <HtmlTooltip
                      title={
                        <div className={Styles.ToolTipWrapper}>
                          {toolTipTitles.map((item, index) =>
                            toolTipTitle(item.title, item.detail, index),
                          )}
                        </div>
                      }
                      placement="right-start"
                    >
                      <InfoIcon
                        style={{ color: Colors.tooltipGreyBackground }}
                        className={Styles.infoIcon}
                      ></InfoIcon>
                    </HtmlTooltip>
                  </div>
                  <div className={Styles.PrivacyToggleContainer}>
                    <IFToggle
                      ref={chargePointBlockRef}
                      height={24}
                      fontSize={12}
                      checkedText={t('ChargePointBlockToggle.Active')}
                      uncheckedText={t('ChargePointBlockToggle.Blocked')}
                      CheckedIcon={IFsvg.EncodedUnblock(Colors.primary)}
                      UncheckedIcon={IFsvg.EncodedBlock(Colors.primary)}
                      readOnly={(chargePoint && !isEdit) || isConnecting}
                      defaultChecked={
                        chargePoint?.isBlocked ? chargePoint?.isBlocked : true
                      }
                      onChange={(value) => setIsBlocked(value)}
                    />
                  </div>
                </div>
              ) : (
                <div className={Styles.NameAndToggleContainer}>
                  <div className={Styles.ChargePointNameContainer}>
                    <div className={Styles.ChargePointNameWrapper}>
                      <div
                        className={Styles.ChargePointStationNameContainer}
                        onClick={() => {
                          scrollStationListToIndex(stationSelectedIndex)
                        }}
                        style={{
                          backgroundColor: increaseBrightness(
                            Colors.primary,
                            10,
                          ),
                        }}
                      >
                        <IFText
                          style={{ color: Colors.white }}
                          className={Styles.NameText}
                        >
                          {selectedStation ? selectedStation.name : ''}
                        </IFText>
                      </div>
                      <div
                        className={Styles.ChargePointName}
                        style={{
                          border: `1.5px solid ${increaseBrightness(
                            Colors.primary,
                            10,
                          )}`,
                        }}
                      >
                        <IFText
                          style={{ color: Colors.text }}
                          className={Styles.NameText}
                        >
                          {chargePointName ? chargePointName : ''}
                        </IFText>
                      </div>
                    </div>
                  </div>
                  <div className={Styles.infoContainer}>
                    {!isConnecting && (
                      <HtmlTooltip
                        title={
                          <div className={Styles.ToolTipWrapper}>
                            {toolTipTitles.map((item, index) =>
                              toolTipTitle(item.title, item.detail, index),
                            )}
                          </div>
                        }
                        placement="right-start"
                      >
                        <InfoIcon
                          style={{ color: Colors.tooltipGreyBackground }}
                          className={Styles.infoIcon}
                        ></InfoIcon>
                      </HtmlTooltip>
                    )}
                  </div>
                  <div className={Styles.PrivacyToggleContainer}>
                    {!isConnecting && (
                      <IFToggle
                        ref={chargePointBlockRef}
                        height={24}
                        fontSize={12}
                        checkedText={t('ChargePointBlockToggle.Active')}
                        uncheckedText={t('ChargePointBlockToggle.Blocked')}
                        CheckedIcon={IFsvg.EncodedUnblock(Colors.primary)}
                        UncheckedIcon={IFsvg.EncodedBlock(Colors.primary)}
                        readOnly={(chargePoint && !isEdit) || isConnecting}
                        defaultChecked={
                          chargePoint?.isBlocked
                            ? chargePoint?.isBlocked
                            : false
                        }
                        onChange={(value) => setIsBlocked(value)}
                      />
                    )}
                  </div>
                </div>
              )}
              {fetchChargePointListRequestState === RequestState.LOADING ||
              fetchChargePointRequestState === RequestState.LOADING ||
              fetchStationListRequestState === RequestState.LOADING ? (
                <div className={Styles.DateSkeleton}>
                  <IFSkeleton variant="text" width="8rem" height=" 1.5rem" />
                </div>
              ) : (
                <div className={Styles.DateAndToggle}>
                  <div
                    style={{ color: Colors.black }}
                    className={Styles.DateContainer}
                  >
                    <Icon
                      sx={{ fontSize: '16px !important' }}
                      component={DateRangeIcon}
                    />
                    <IFText>
                      &nbsp;
                      {chargePoint
                        ? moment(chargePoint.createdAt).format(
                            'MMM DD, YYYY HH:mm',
                          )
                        : ''}
                    </IFText>
                  </div>
                  {isEdit ||
                  (chargePoint &&
                    !chargePoint.isActivated &&
                    !isConnecting &&
                    operatorUser.permissions.includes(
                      InfinityEnums.OperatorUserPermission.CAN_EDIT_CHARGEPOINT,
                    )) ? (
                    <div className={Styles.PrivacyToggleContainer}>
                      <IFToggle
                        ref={chargePointPrivacyRef}
                        height={24}
                        fontSize={12}
                        checkedText={t('ChargePointPrivacyToggle.Public')}
                        uncheckedText={t('ChargePointPrivacyToggle.Private')}
                        CheckedIcon={IFsvg.EncodedUnlock(Colors.primary)}
                        UncheckedIcon={IFsvg.EncodedLock(Colors.primary)}
                        readOnly={
                          (chargePoint && chargePoint.isActivated && !isEdit) ||
                          isConnecting
                        }
                        defaultChecked={!chargePoint?.isPrivate}
                        onChange={(value) => setIsPrivate(value)}
                      />
                    </div>
                  ) : (
                    <div className={Styles.PrivacyToggleContainer}>
                      <IFToggle
                        ref={chargePointPrivacyRef}
                        height={24}
                        fontSize={12}
                        checkedText={t('ChargePointPrivacyToggle.Public')}
                        uncheckedText={t('ChargePointPrivacyToggle.Private')}
                        CheckedIcon={IFsvg.EncodedUnlock(Colors.primary)}
                        UncheckedIcon={IFsvg.EncodedLock(Colors.primary)}
                        readOnly={
                          (chargePoint && chargePoint.isActivated && !isEdit) ||
                          isConnecting
                        }
                        defaultChecked={!chargePoint?.isPrivate}
                        onChange={(value) => setIsPrivate(value)}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className={Styles.UidContainer}>
              {fetchChargePointListRequestState === RequestState.LOADING ||
              fetchChargePointRequestState === RequestState.LOADING ||
              fetchStationListRequestState === RequestState.LOADING ? (
                <IFSkeleton variant="text" width="8rem" height=" 2rem" />
              ) : (
                <div className={Styles.ChargePointUidContainer}>
                  {handleChargingIcon(maxPower)}
                  <IFText
                    className={Styles.UIDText}
                    style={{ color: Colors.text }}
                  >
                    {chargePoint ? chargePoint.huid : ''}
                  </IFText>
                </div>
              )}
            </div>
            <Scrollbars
              className={
                isEdit || (chargePoint && !chargePoint.isActivated)
                  ? Styles.ScrollParentDisable
                  : Styles.ScrollParent
              }
            >
              <div className={isEdit ? '' : Styles.ChargePointSpecsWrapper}>
                <div className={Styles.ConnectorsWrapper}>
                  <div className={Styles.ConnectorsTextContainer}>
                    {fetchChargePointListRequestState ===
                      RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div>
                        <IFSkeleton
                          style={{ height: '1.5rem', width: '6rem' }}
                        />
                      </div>
                    ) : (
                      <IFText style={{ color: Colors.text }} is>
                        {t('ChargePointDetails.Connectors')}
                      </IFText>
                    )}
                  </div>
                  <div className={Styles.ConnectorsContainer}>
                    <ConnectorList
                      ref={connectorListRef}
                      isEdit={
                        isEdit ||
                        (chargePoint ? !chargePoint.isActivated : false)
                      }
                      isLoading={isConnecting}
                      isChargePointOffline={
                        chargePoint ? !chargePoint.isOnline : false
                      }
                      onMaxPowerChange={(value, id) =>
                        handleMaxPowerChange(value, id)
                      }
                      onStatusChange={(value, id) =>
                        handleStatusChange(value, id)
                      }
                      onTariffChange={(value, id) =>
                        handleTariffChange(value, id)
                      }
                      onTypeChange={(value, id) => handleTypeChange(value, id)}
                      onVisibleChange={(value, id) => {
                        handleVisibleChange(value, id)
                      }}
                      onSocLimitChange={(value, id) =>
                        handleSocLimitChange(value, id)
                      }
                    />
                  </div>
                </div>
              </div>
              {isEdit ||
              (chargePoint &&
                !chargePoint.isActivated &&
                !(
                  fetchChargePointListRequestState === RequestState.LOADING ||
                  fetchChargePointRequestState === RequestState.LOADING ||
                  fetchStationListRequestState === RequestState.LOADING
                )) ? null : (
                <div className={Styles.logsWrapper}>
                  <div className={Styles.logsHeader}>
                    <div className={Styles.TabsContainer}>
                      <ChargePointDetailsTabs
                        initialIndex={selectedDetails}
                        ref={chargePointDetailsTabsRef}
                        onValueChange={(index) => handleSelectedTab(index)}
                        isLoading={
                          fetchChargePointListRequestState ===
                            RequestState.LOADING ||
                          fetchChargePointRequestState ===
                            RequestState.LOADING ||
                          fetchStationListRequestState ===
                            RequestState.LOADING ||
                          !logListLastUpdated
                        }
                        canViewUptimeStats={operatorUser.permissions.includes(
                          InfinityEnums.OperatorUserPermission
                            .CAN_VIEW_CHARGEPOINT_UPTIME,
                        )}
                        canViewOperatorUserActions={operatorUser.permissions.includes(
                          InfinityEnums.OperatorUserPermission
                            .CAN_VIEW_OPERATOR_USER_ACTIONS_CHARGE_POINT,
                        )}
                      />

                      {(fetchChargePointListRequestState ===
                        RequestState.LOADING ||
                        fetchStationListRequestState === RequestState.LOADING ||
                        fetchChargePointLogListRequestState ===
                          RequestState.LOADING ||
                        fetchChargePointRequestState === RequestState.LOADING ||
                        fetchChargePointTransactionListRequestState ===
                          RequestState.LOADING) &&
                      !isChargePointLogsLive ? (
                        <div className={Styles.RefreshIconTextContainer}>
                          <div>
                            <div className={Styles.RefreshIconTextSkeleton}>
                              <div className={Styles.RefreshIconSkeleton}>
                                <IFSkeleton
                                  width="1rem"
                                  height="1rem"
                                  variant="circular"
                                />
                              </div>
                              <IFSkeleton
                                height="1.5rem"
                                className={Styles.RefreshTextSkeleton}
                              />
                            </div>

                            <IFSkeleton
                              height="1.25rem"
                              className={Styles.RefreshTextDateSkeleton}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className={Styles.RefreshIconTextContainer}>
                          <div
                            className={Styles.RefreshTextContainer}
                            style={{
                              opacity:
                                selectedDetails == 0
                                  ? isChargePointLogsLive
                                    ? 0
                                    : 1
                                  : 1,
                            }}
                          >
                            {fetchChargePointListRequestState ===
                              RequestState.LOADING ||
                            fetchStationListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointTransactionListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointUptimeStatisticsRequestState ===
                              RequestState.LOADING ||
                            fetchConnectorsUtilizationRequestState ==
                              RequestState.LOADING ||
                            fetchOperatorUserActionsChargePointRequestState ===
                              RequestState.LOADING ? (
                              <div>
                                <div className={Styles.RefreshIconTextSkeleton}>
                                  <div className={Styles.RefreshIconSkeleton}>
                                    <IFSkeleton
                                      width="1rem"
                                      height="1rem"
                                      variant="circular"
                                    />
                                  </div>
                                  <IFSkeleton
                                    height="1.5rem"
                                    className={Styles.RefreshTextSkeleton}
                                  />
                                </div>

                                <IFSkeleton
                                  height="1.25rem"
                                  className={Styles.RefreshTextDateSkeleton}
                                />
                              </div>
                            ) : (
                              <>
                                <div className={Styles.LiveLogs}>
                                  <div
                                    className={Styles.RefreshIcon}
                                    onClick={() => {
                                      if (refreshingLogs) return
                                      setRefreshingLogs(true)
                                      if (selectedDetails === 0) {
                                        setChargePointLogPaginationOffset(0)
                                        fetchChargePointLogList(
                                          chargePointLogFilter,
                                          0,
                                          chargePoint._id,
                                          ascendingLogs,
                                        )
                                      } else if (selectedDetails === 1) {
                                        setChargePointTransactionPaginationOffset(
                                          0,
                                        )
                                        fetchChargePointTransactionList(
                                          chargePointTransactionFilter,
                                          0,
                                          chargePoint._id,
                                          ascendingTransactions,
                                        )
                                      } else if (
                                        selectedDetails === 2 &&
                                        canViewUptimeStats
                                      ) {
                                        setChargePointStatisticsFilter(
                                          getDefaultChargePointStatisticsFilter(),
                                        )
                                        fetchChargePointUptimeStatistics(
                                          chargePoint._id,
                                          chargePointStatisticsFilter,
                                        )
                                        fetchConnectorsUtilization(
                                          chargePoint._id,
                                          chargePointStatisticsFilter,
                                        )
                                      } else if (
                                        selectedDetails ===
                                        (canViewUptimeStats ? 3 : 2)
                                      ) {
                                        setOperatorUserActionsPaginationOffset(
                                          0,
                                        )
                                        fetchOperatorUserActionsChargePoint(
                                          chargePoint._id,
                                          operatorUserActionsFilters,
                                          0,
                                        )
                                      }
                                    }}
                                  >
                                    <div className={Styles.RefreshSvg}>
                                      <IFsvg.refresh
                                        height={16}
                                        width={16}
                                        fill={Colors.black}
                                      />
                                    </div>
                                    <IFText
                                      className={Styles.RefreshText}
                                      style={{ color: Colors.black }}
                                    >
                                      {t('ChargePointDetails.lastUpdated')}
                                    </IFText>
                                  </div>
                                </div>
                                <IFText className={Styles.RefreshTextDate}>
                                  {selectedDetails === 0 && logListLastUpdated
                                    ? moment(logListLastUpdated).format(
                                        'MMM DD, YYYY HH:mm:ss',
                                      )
                                    : selectedDetails === 1 &&
                                      transactionListLastUpdated
                                    ? moment(transactionListLastUpdated).format(
                                        'MMM DD, YYYY HH:mm:ss',
                                      )
                                    : selectedDetails === 2 &&
                                      cpUptimeLastUpdated &&
                                      canViewUptimeStats
                                    ? moment(cpUptimeLastUpdated).format(
                                        'MMM DD, YYYY HH:mm:ss',
                                      )
                                    : selectedDetails ===
                                        (canViewUptimeStats ? 3 : 2) &&
                                      operatorUserActionsLastUpdated
                                    ? moment(
                                        operatorUserActionsLastUpdated,
                                      ).format('MMM DD, YYYY HH:mm:ss')
                                    : ''}
                                </IFText>
                              </>
                            )}
                          </div>

                          {selectedDetails == 0 ? (
                            fetchChargePointListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointRequestState ===
                              RequestState.LOADING ||
                            fetchStationListRequestState ===
                              RequestState.LOADING ||
                            !logListLastUpdated ? (
                              <div className={Styles.LiveLogsToggleSkeleton}>
                                <IFSkeleton
                                  width="4rem"
                                  height="2rem"
                                  variant="text"
                                  style={{ alignSelf: 'center' }}
                                />
                              </div>
                            ) : (
                              <div className={Styles.LiveLogsToggle}>
                                <IFToggle
                                  height={22}
                                  fontSize={12}
                                  checkedText={t('ChargePointLogsToggle.Live')}
                                  uncheckedText={t(
                                    'ChargePointLogsToggle.Live',
                                  )}
                                  CheckedIcon={IFsvg.liveEncoded({
                                    fill: Colors.primary,
                                    width: '14',
                                    height: '14',
                                  })}
                                  UncheckedIcon={IFsvg.notLiveEncoded({
                                    fill: Colors.primary,
                                    width: '14',
                                    height: '14',
                                  })}
                                  readOnly={ascendingLogs}
                                  defaultChecked={isChargePointLogsLive}
                                  onChange={(value) => {
                                    setIsChargePointLogsLive(value)
                                  }}
                                />
                              </div>
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </div>
                    <div className={Styles.FilterContainer}>
                      {(selectedDetails === 0 &&
                        !(
                          chargePointLogs.length === 0 &&
                          checkFilterEmpty(chargePointLogFilter)
                        )) ||
                      fetchChargePointListRequestState ===
                        RequestState.LOADING ||
                      fetchChargePointRequestState === RequestState.LOADING ||
                      fetchStationListRequestState === RequestState.LOADING ||
                      fetchChargePointLogListRequestState ===
                        RequestState.LOADING ||
                      updateChargePointRequestState === RequestState.LOADING ? (
                        <IFFilter
                          ref={logRef}
                          key={'IFFilter_Logs'}
                          onFilterChange={(newFilter) => {
                            handleChargePointLogs(newFilter)
                            setIsFiltersSelected(true)
                          }}
                          downloadChargePointLogs={operatorUser.permissions.includes(
                            InfinityEnums.OperatorUserPermission
                              .CAN_DOWNLOAD_STATION_LOGS,
                          )}
                          filters={chargePointLogFilter}
                          textFieldPlaceholder={t(
                            'ChargePointDetails.FilterLogsBy',
                          )}
                          isLoading={
                            fetchChargePointListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointRequestState ===
                              RequestState.LOADING ||
                            fetchStationListRequestState ===
                              RequestState.LOADING ||
                            (fetchChargePointLogListRequestState ===
                              RequestState.LOADING &&
                              !isFiltersSelected)
                          }
                          canSort={true}
                          ascending={ascendingLogs}
                          onSortChange={() => {
                            setIsFiltersSelected(true)
                            clearChargePointLogs()
                            setChargePointLogPaginationOffset(0)
                            fetchChargePointLogList(
                              chargePointLogFilter,
                              0,
                              chargePoint._id,
                              !ascendingLogs,
                            )
                            setAscendingLogs((prev) => {
                              return !prev
                            })
                          }}
                        />
                      ) : (selectedDetails === 1 &&
                          !(
                            chargePointTransactions.length === 0 &&
                            checkFilterEmpty(chargePointTransactionFilter)
                          )) ||
                        fetchChargePointListRequestState ===
                          RequestState.LOADING ||
                        fetchChargePointRequestState === RequestState.LOADING ||
                        fetchStationListRequestState === RequestState.LOADING ||
                        fetchChargePointTransactionListRequestState ===
                          RequestState.LOADING ||
                        updateChargePointRequestState ===
                          RequestState.LOADING ? (
                        <IFFilter
                          ref={transactionRef}
                          key={'IFFilter_Transactions'}
                          onFilterChange={(newFilter) => {
                            handleChargePointTransactions(newFilter)
                            setIsFiltersSelected(true)
                          }}
                          filters={chargePointTransactionFilter}
                          textFieldPlaceholder={t(
                            'ChargePointDetails.FilterLogsBy',
                          )}
                          downloadTransactions={operatorUser.permissions.includes(
                            InfinityEnums.OperatorUserPermission
                              .CAN_DOWNLOAD_TRANSACTIONS,
                          )}
                          isLoading={
                            fetchChargePointListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointRequestState ===
                              RequestState.LOADING ||
                            fetchStationListRequestState ===
                              RequestState.LOADING ||
                            (fetchChargePointTransactionListRequestState ===
                              RequestState.LOADING &&
                              !isFiltersSelected)
                          }
                          canSort={true}
                          ascending={ascendingTransactions}
                          onSortChange={() => {
                            setIsFiltersSelected(true)
                            clearChargePointTransactions()
                            setChargePointTransactionPaginationOffset(0)
                            fetchChargePointTransactionList(
                              chargePointTransactionFilter,
                              0,
                              chargePoint._id,
                              !ascendingTransactions,
                            )
                            setAscendingTransactions((prev) => {
                              return !prev
                            })
                          }}
                        />
                      ) : selectedDetails === 2 && canViewUptimeStats ? (
                        <IFFilter
                          key={'IFFilter_ChargepointStatistics'}
                          onFilterChange={(newFilter, index) => {
                            const adjustedFilter = newFilter.map((filter) => {
                              if (filter.value.length === 0) {
                                filter.value =
                                  chargePointStatisticsFilter[index].value
                              }
                              filter.initialValue = filter.value

                              return filter
                            })
                            setChargePointStatisticsFilter(adjustedFilter)
                          }}
                          filters={chargePointStatisticsFilter}
                          textFieldPlaceholder={t(
                            'ChargePointDetails.ChargePointUptimeFilter',
                          )}
                          isLoading={
                            fetchChargePointListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointRequestState ===
                              RequestState.LOADING ||
                            fetchStationListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointUptimeStatisticsRequestState ===
                              RequestState.LOADING ||
                            fetchConnectorsUtilizationRequestState ==
                              RequestState.LOADING
                          }
                          disableKeyword={true}
                          fixedFilters={true}
                          disableFutureDates={true}
                        />
                      ) : selectedDetails === (canViewUptimeStats ? 3 : 2) &&
                        !(
                          operatorUserActionsChargePoint.length === 0 &&
                          checkFilterEmpty(operatorUserActionsFilters) &&
                          fetchOperatorUserActionsChargePointRequestState !==
                            RequestState.LOADING
                        ) ? (
                        <IFFilter
                          key={'IFFilter_OperatorUserActions'}
                          onFilterChange={(newFilter) => {
                            resetOperatorUserActionsChargePoint()
                            setOperatorUserActionsFilters(newFilter)
                            fetchOperatorUserActionsChargePoint(
                              chargePoint._id,
                              newFilter,
                              0,
                            )
                          }}
                          filters={operatorUserActionsFilters}
                          textFieldPlaceholder={t(
                            'ChargePointDetails.OperatorUserActionsFilter',
                          )}
                          isLoading={
                            fetchChargePointListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointRequestState ===
                              RequestState.LOADING ||
                            fetchStationListRequestState ===
                              RequestState.LOADING ||
                            fetchChargePointUptimeStatisticsRequestState ===
                              RequestState.LOADING ||
                            fetchConnectorsUtilizationRequestState ==
                              RequestState.LOADING ||
                            fetchOperatorUserActionsChargePointRequestState ===
                              RequestState.LOADING
                          }
                          disableFutureDates={true}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className={Styles.logsContent}>
                    <div className={Styles.logsBorder}>
                      <div className={Styles.ListContainer}>
                        <div className={Styles.LogsContainer}>
                          {selectedDetails === 1 ? (
                            <ChargePointTransactionList
                              ascending={ascendingTransactions}
                            />
                          ) : selectedDetails === 0 ? (
                            <ChargePointLogList ascending={ascendingLogs} />
                          ) : selectedDetails === 2 && canViewUptimeStats ? (
                            <>
                              {fetchChargePointUptimeStatisticsRequestState ===
                                RequestState.SUCCEEDED &&
                              !monitorIsLoadingFlag ? (
                                <>
                                  <StationUptimeMonitor
                                    chartWidth={'100%'}
                                    onlineSeriesData={
                                      chargePointUptimeData.uptimeGraphSeries[0]
                                        .data
                                    }
                                    offlineSeriesData={
                                      chargePointUptimeData.uptimeGraphSeries[1]
                                        .data
                                    }
                                    unstableSeriesData={
                                      chargePointUptimeData.uptimeGraphSeries[2]
                                        .data
                                    }
                                    startTimestamp={new Date(
                                      uptimeGraphStartTimestamp,
                                    ).getTime()}
                                    endTimestamp={new Date(
                                      chargePointUptimeData.graphEndTimestamp,
                                    ).getTime()}
                                    onlinePercentage={
                                      chargePointUptimeData.uptimePercentages
                                        .online
                                    }
                                    offlinePercentage={
                                      chargePointUptimeData.uptimePercentages
                                        .offline
                                    }
                                    unstablePercentage={
                                      chargePointUptimeData.uptimePercentages
                                        .unstable
                                    }
                                    noData={chargePointUptimeData.isEmpty}
                                  />
                                </>
                              ) : fetchChargePointUptimeStatisticsRequestState ===
                                  RequestState.LOADING ||
                                monitorIsLoadingFlag ? (
                                <div className={Styles.ChartSkeletonContainer}>
                                  <div
                                    className={Styles.ChartResetButtonSkeleton}
                                  >
                                    <IFButtonSkeleton size="xsm" />
                                  </div>

                                  <IFSkeleton
                                    variant="text"
                                    width="100%"
                                    height="9.5rem"
                                  />
                                </div>
                              ) : null}

                              {fetchConnectorsUtilizationRequestState ===
                                RequestState.SUCCEEDED &&
                              !monitorIsLoadingFlag ? (
                                <>
                                  <ConnectorUtilization
                                    chartWidth={'100%'}
                                    chartHeight={calculateConnectorUtilizationGraphHeight()}
                                    availableSeriesData={
                                      connectorsUtilizationData
                                        .utilizationGraphSeries[0].data
                                    }
                                    chargingSeriesData={
                                      connectorsUtilizationData
                                        .utilizationGraphSeries[1].data
                                    }
                                    occupiedSeriesData={
                                      connectorsUtilizationData
                                        .utilizationGraphSeries[2].data
                                    }
                                    unavailableSeriesData={
                                      connectorsUtilizationData
                                        .utilizationGraphSeries[3].data
                                    }
                                    faultedSeriesData={
                                      connectorsUtilizationData
                                        .utilizationGraphSeries[4].data
                                    }
                                    availablePercentage={
                                      connectorsUtilizationData
                                        .utilizationPercentages.available
                                    }
                                    chargingPercentage={
                                      connectorsUtilizationData
                                        .utilizationPercentages.charging
                                    }
                                    occupiedPercentage={
                                      connectorsUtilizationData
                                        .utilizationPercentages.occupied
                                    }
                                    unavailablePercentage={
                                      connectorsUtilizationData
                                        .utilizationPercentages.unavailable
                                    }
                                    faultedPercentage={
                                      connectorsUtilizationData
                                        .utilizationPercentages.faulted
                                    }
                                    startTimestamp={new Date(
                                      connectorGraphStartTimestamp,
                                    ).getTime()}
                                    endTimestamp={new Date(
                                      connectorsUtilizationData.graphEndTimestamp,
                                    ).getTime()}
                                    noData={connectorsUtilizationData.isEmpty}
                                  />
                                </>
                              ) : fetchConnectorsUtilizationRequestState ===
                                  RequestState.LOADING ||
                                monitorIsLoadingFlag ? (
                                <div className={Styles.ChartSkeletonContainer}>
                                  <div
                                    className={Styles.ChartResetButtonSkeleton}
                                  >
                                    <IFButtonSkeleton size="xsm" />
                                  </div>

                                  <IFSkeleton
                                    variant="text"
                                    width="100%"
                                    height="9.5rem"
                                  />
                                </div>
                              ) : null}
                            </>
                          ) : selectedDetails ===
                            (canViewUptimeStats ? 3 : 2) ? (
                            <OperatorUserActionsChargePoint
                              chargePoint={chargePoint}
                              selectedDetails={selectedDetails}
                              canViewUptimeStats={canViewUptimeStats}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Scrollbars>
          </LeftContainer>

          {chargePoint && isEdit && chargePoint.isActivated ? (
            <div className={Styles.RightContainerEdit}>
              <IFTooltipIconsLoading
                onClick={handleMoveModal}
                tooltipPlacement={'left'}
                title={t('ChargePointDetails.MoveButtonText')}
                Icon={IFsvg.Move}
                FilledIcon={IFsvg.Move}
                isLoading={false}
                size={26}
                iconClassname={Styles.iconContainer}
              />
              {operatorUser.permissions.includes(
                InfinityEnums.OperatorUserPermission.CAN_DELETE_CHARGEPOINT,
              ) ? (
                <IFTooltipIconsLoading
                  onClick={() => confirmDeleteDialog.current.show()}
                  tooltipPlacement={'left'}
                  iconColor={Colors.red}
                  iconBackgroundColor={Colors.red}
                  title={t('ChargePointDetails.DeleteButtonText')}
                  Icon={IFsvg.Delete}
                  FilledIcon={IFsvg.Delete}
                  isLoading={false}
                  size={26}
                  iconClassname={Styles.iconContainer}
                />
              ) : null}
              <DividerDivHorizontal className={Styles.DividerHorizontal} />
              <IFTooltipIconsLoading
                onClick={handleCancel}
                tooltipPlacement={'left'}
                title={t('ChargePointDetails.CancelButtonText')}
                Icon={IFsvg.Cancel}
                FilledIcon={IFsvg.Cancel}
                isLoading={false}
                size={26}
                iconClassname={Styles.iconContainer}
              />
              {updateChargePointRequestState === RequestState.LOADING &&
              !isEdit ? (
                <div className={Styles.iconContainerSkeleton}>
                  <IFSkeleton variant="circular" width="26px" height="26px" />
                </div>
              ) : (
                <IFTooltipIconsLoading
                  onClick={() => {
                    handleSubmitRef.current()
                  }}
                  tooltipPlacement={'left'}
                  title={t('ChargePointDetails.DoneButtonText')}
                  Icon={IFsvg.Done}
                  FilledIcon={IFsvg.Done}
                  isLoading={
                    updateChargePointRequestState === RequestState.LOADING ||
                    changeChargePointAvailabilityRequestState ===
                      RequestState.LOADING ||
                    deleteChargePointTariffsRequestState ===
                      RequestState.LOADING ||
                    addChargePointTariffsRequestState ===
                      RequestState.LOADING ||
                    addChargePointAccessGroupsBulkRequestState ===
                      RequestState.LOADING ||
                    deleteChargePointAccessGroupsBulkRequestState ===
                      RequestState.LOADING ||
                    deleteChargePointPrivacyRulesRequestState ===
                      RequestState.LOADING ||
                    addChargePointPrivacyRulesRequestState ===
                      RequestState.LOADING
                  }
                  size={26}
                  iconClassname={Styles.iconContainer}
                  animationDisabled={false}
                />
              )}
            </div>
          ) : (
            <div className={canEdit ? Styles.RightContainer : ''}>
              {((chargePoint && chargePoint.isActivated) ||
                fetchChargePointListRequestState === RequestState.LOADING ||
                fetchChargePointRequestState === RequestState.LOADING ||
                fetchStationListRequestState === RequestState.LOADING) && (
                <div className={Styles.TopButtonsContainer}>
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_VIEW_CONFIGURATION,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={handleConfigurationOpen}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.ConfigurationButtonText')}
                        Icon={IFsvg.Tune}
                        FilledIcon={IFsvg.Tune}
                        isLoading={false}
                        size={26}
                        iconClassname={Styles.iconContainer}
                      />
                    )
                  ) : null}
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_VIEW_CONFIGURATION,
                  ) && (
                    <DividerDivHorizontal
                      className={Styles.DividerHorizontal}
                    />
                  )}
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_VIEW_DIAGNOSTICS,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          uploadDiagnosticsRef.current.show()
                        }}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.DiagnosticsButtonText')}
                        Icon={IFsvg.FindInPage}
                        FilledIcon={IFsvg.FindInPage}
                        isLoading={false}
                        size={26}
                        iconClassname={Styles.iconContainer}
                      />
                    )
                  ) : null}
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_VIEW_FIRMWARE,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          firmwareRef.current.show()
                        }}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.FirmwareButtonText')}
                        Icon={IFsvg.SystemUpdate}
                        FilledIcon={IFsvg.SystemUpdate}
                        isLoading={false}
                        size={26}
                        iconClassname={Styles.iconContainer}
                      />
                    )
                  ) : null}
                  {(operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_VIEW_DIAGNOSTICS,
                  ) ||
                    operatorUser.permissions.includes(
                      InfinityEnums.OperatorUserPermission.CAN_VIEW_FIRMWARE,
                    )) && (
                    <DividerDivHorizontal
                      className={Styles.DividerHorizontal}
                    />
                  )}
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission
                      .CAN_EDIT_CHARGEPOINT_CHARGING_PROFILE,
                  ) &&
                  operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission
                      .CAN_VIEW_COMPOSITE_SCHEDULE,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          fetchChargePointCompositeSchedule(
                            chargePoint._id,
                            chargePoint.evses?.flatMap(
                              (evse) => evse.connectors || [],
                            )[0]?.uid,
                            weekToSecs,
                            'A',
                          )
                          ProfileModalRef.current.show()
                        }}
                        tooltipPlacement={'left'}
                        title={t('ChargingProfileModal.CompositeSchedule')}
                        Icon={IFsvg.PendingActions}
                        FilledIcon={IFsvg.PendingActions}
                        size={26}
                        iconClassname={Styles.iconContainer}
                        isLoading={false}
                      />
                    )
                  ) : null}

                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_EDIT_LOCAL_LIST,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          fetchChargePointLocalList(chargePoint._id)
                          localListRef.current.show()
                        }}
                        tooltipPlacement={'left'}
                        title={t('LocalListModal.LocalAuthorizationList')}
                        Icon={IFsvg.PassKey}
                        FilledIcon={IFsvg.PassKey}
                        size={26}
                        iconClassname={Styles.iconContainer}
                        isLoading={false}
                      />
                    )
                  ) : null}
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_USE_TERMINAL,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          terminalRef.current.show()
                        }}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.Terminal')}
                        Icon={IFsvg.Terminal}
                        FilledIcon={IFsvg.Terminal}
                        size={26}
                        iconClassname={Styles.iconContainer}
                        isLoading={false}
                      />
                    )
                  ) : null}
                  {(operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission
                      .CAN_EDIT_CHARGEPOINT_CHARGING_PROFILE,
                  ) ||
                    operatorUser.permissions.includes(
                      InfinityEnums.OperatorUserPermission.CAN_EDIT_LOCAL_LIST,
                    ) ||
                    operatorUser.permissions.includes(
                      InfinityEnums.OperatorUserPermission.CAN_USE_TERMINAL,
                    )) && (
                    <DividerDivHorizontal
                      className={Styles.DividerHorizontal}
                    />
                  )}
                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission.CAN_CLEAR_CACHE,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          OCPPServices.clearCache(chargePoint._id)
                        }}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.ClearCache')}
                        Icon={IFsvg.DeleteSweep}
                        FilledIcon={IFsvg.DeleteSweep}
                        isLoading={
                          clearChargePointCacheRequestState ===
                          RequestState.LOADING
                        }
                        size={26}
                        iconClassname={Styles.iconContainer}
                        animationDisabled={false}
                      />
                    )
                  ) : null}

                  {operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission
                      .CAN_HARD_RESET_CHARGEPOINT,
                  ) ||
                  operatorUser.permissions.includes(
                    InfinityEnums.OperatorUserPermission
                      .CAN_SOFT_RESET_CHARGEPOINT,
                  ) ? (
                    fetchChargePointListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => resetDialog.current.show()}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.ResetButtonText')}
                        Icon={IFsvg.Restart}
                        FilledIcon={IFsvg.Restart}
                        isLoading={false}
                        size={26}
                        iconClassname={Styles.iconContainer}
                      />
                    )
                  ) : null}
                </div>
              )}
              {operatorUser.permissions.includes(
                InfinityEnums.OperatorUserPermission.CAN_EDIT_CHARGEPOINT,
              ) ? (
                (chargePoint && chargePoint.isActivated) ||
                fetchChargePointListRequestState === RequestState.LOADING ||
                fetchChargePointRequestState === RequestState.LOADING ||
                fetchStationListRequestState === RequestState.LOADING ? (
                  <div className={Styles.ResetButtonContainer}>
                    {fetchChargePointListRequestState ===
                      RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={handleDownloadPDF}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.DownloadQr')}
                        Icon={IFsvg.QrCode}
                        FilledIcon={IFsvg.QrCode}
                        isLoading={false}
                        size={26}
                        iconClassname={Styles.iconContainer}
                      />
                    )}
                    <DividerDivHorizontal
                      className={Styles.DividerHorizontal}
                    />
                    {operatorUser.permissions.includes(
                      InfinityEnums.OperatorUserPermission.CAN_VIEW_ALERT,
                    ) ? (
                      fetchChargePointListRequestState ===
                        RequestState.LOADING ||
                      fetchChargePointRequestState === RequestState.LOADING ||
                      fetchStationListRequestState === RequestState.LOADING ? (
                        <div className={Styles.iconContainerSkeleton}>
                          <IFSkeleton
                            variant="circular"
                            width="26px"
                            height="26px"
                          />
                        </div>
                      ) : (
                        <IFTooltipIconsLoading
                          onClick={handleAlertModalOpen}
                          tooltipPlacement={'left'}
                          title={t('ChargePointDetails.AlertButtonText')}
                          Icon={IFsvg.Alert}
                          FilledIcon={IFsvg.Alert}
                          isLoading={false}
                          size={26}
                          iconClassname={Styles.iconContainer}
                        />
                      )
                    ) : null}
                    {operatorUser.permissions.includes(
                      InfinityEnums.OperatorUserPermission.CAN_VIEW_ALERT,
                    ) && (
                      <DividerDivHorizontal
                        className={Styles.DividerHorizontal}
                      />
                    )}
                    {fetchChargePointListRequestState ===
                      RequestState.LOADING ||
                    fetchStationListRequestState === RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : !operatorUser.permissions.includes(
                        InfinityEnums.OperatorUserPermission
                          .CAN_EDIT_CHARGEPOINT,
                      ) ? null : (
                      <IFTooltipIconsLoading
                        onClick={() => {
                          setIsEdit(true)
                          if (!fetchConnectorTypesFlag) {
                            fetchConnectorTypes()
                            setFetchConnectorsTypesFlag(true)
                          }
                        }}
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.EditButtonText')}
                        Icon={IFsvg.Edit}
                        FilledIcon={IFsvg.Edit}
                        isLoading={false}
                        size={26}
                        iconClassname={Styles.iconContainer}
                      />
                    )}
                  </div>
                ) : (
                  <div className={Styles.InactiveButtonContainer}>
                    {fetchChargePointListRequestState ===
                      RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() => confirmDeleteDialog.current.show()}
                        tooltipPlacement="left"
                        title={t('ChargePointDetails.DeleteButtonText')}
                        Icon={IFsvg.Delete}
                        FilledIcon={IFsvg.Delete}
                        size={26}
                        iconColor={Colors.red}
                        iconBackgroundColor={Colors.red}
                        iconClassname={Styles.iconContainer}
                      />
                    )}
                    {fetchChargePointListRequestState ===
                      RequestState.LOADING ||
                    fetchChargePointRequestState === RequestState.LOADING ? (
                      <div className={Styles.iconContainerSkeleton}>
                        <IFSkeleton
                          variant="circular"
                          width="26px"
                          height="26px"
                        />
                      </div>
                    ) : (
                      <IFTooltipIconsLoading
                        onClick={() =>
                          isConnecting
                            ? () => {}
                            : handleSubmitRef.current(true)
                        }
                        tooltipPlacement={'left'}
                        title={t('ChargePointDetails.ActivateButtonText')}
                        Icon={IFsvg.Done}
                        FilledIcon={IFsvg.Done}
                        isLoading={
                          updateChargePointRequestState ===
                            RequestState.LOADING ||
                          changeChargePointAvailabilityRequestState ===
                            RequestState.LOADING ||
                          deleteChargePointTariffsRequestState ===
                            RequestState.LOADING ||
                          addChargePointTariffsRequestState ===
                            RequestState.LOADING ||
                          addChargePointAccessGroupsBulkRequestState ===
                            RequestState.LOADING ||
                          deleteChargePointAccessGroupsBulkRequestState ===
                            RequestState.LOADING ||
                          deleteChargePointPrivacyRulesRequestState ===
                            RequestState.LOADING ||
                          addChargePointPrivacyRulesRequestState ===
                            RequestState.LOADING
                        }
                        size={26}
                        iconClassname={Styles.iconContainer}
                        animationDisabled={false}
                        isDead={isConnecting}
                      />
                    )}
                  </div>
                )
              ) : null}
            </div>
          )}
          <IFDialog
            ref={confirmDeleteDialog}
            title={t('ChargePointDetails.DeleteDialogTitle')}
            subtitle={t('ChargePointDetails.DeleteDialogSubtitle')}
            onAction={() => deleteChargePoint(chargePoint._id)}
            actionButtonIcon={
              <Icon
                sx={{ width: '18px !important', height: '18px !important' }}
                component={DeleteOutlineIcon}
              />
            }
            actionButtonText={t('ChargePointDetails.DeleteButtonText')}
            actionButtonColor={Colors.red}
            confirmationText={chargePoint ? chargePoint.huid : ''}
            isLoading={deleteChargePointRequestState === RequestState.LOADING}
          />

          <IFDialog
            titleStyle={{ fontSize: '1.625rem', fontWeight: '600' }}
            dialogWidth="30rem"
            ref={resetDialog}
            title={t('ChargePointDetails.ResetDialogTitle')}
            subtitle={userResetPermissionsText()}
            onAction={() =>
              OCPPServices.resetChargePoint(
                chargePoint._id,
                InfinityEnums.ResetType.HARD,
                () => {
                  resetDialog.current.resetAnimation()
                },
              )
            }
            actionButtonIcon={
              <IFsvg.hardReset height={20} width={20} fill={Colors.white} />
            }
            actionButtonText={t('ChargePointDetails.HardResetButtonText')}
            actionButtonColor={Colors.primary}
            isLoading={resetChargePointRequestState === RequestState.LOADING}
            hasFirstButton={operatorUser.permissions.includes(
              InfinityEnums.OperatorUserPermission.CAN_HARD_RESET_CHARGEPOINT,
            )}
            hasSecondButton={operatorUser.permissions.includes(
              InfinityEnums.OperatorUserPermission.CAN_SOFT_RESET_CHARGEPOINT,
            )}
            secondActionButtonText={t('ChargePointDetails.SoftResetButtonText')}
            secondActionButtonColor={Colors.primary}
            isSecondButtonLoading={
              resetChargePointRequestState === RequestState.LOADING
            }
            secondActionButtonOnClick={() =>
              OCPPServices.resetChargePoint(
                chargePoint._id,
                InfinityEnums.ResetType.SOFT,
                () => {
                  resetDialog.current.resetAnimation()
                },
              )
            }
            secondActionButtonIcon={
              <Icon
                sx={{ width: '18px !important', height: '18px !important' }}
                component={RestartAltIcon}
              />
            }
            animateButtons={true}
          />
          <MoveStationModal ref={moveStationRef} />
          <ConfigurationModal ref={configurationRef} />
          <FirmwareModal
            ref={firmwareRef}
            currentFirmware={chargePoint ? chargePoint.firmwareVersion : ''}
          />
          <UploadDiagnosticsModal ref={uploadDiagnosticsRef} />
          <TerminalModal ref={terminalRef} />
          <AlertModal ref={alertModalRef} />
          <LocalListModal ref={localListRef} />
          <ChargingProfileModal ref={ProfileModalRef} />
        </div>
      )}
    </Fragment>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    setChargePointLogsFilter: (newFilter) =>
      dispatch(ChargePointActions.setChargePointLogsFilter(newFilter)),
    setChargePointTransactionsFilter: (newFilter) =>
      dispatch(ChargePointActions.setChargePointTransactionsFilter(newFilter)),
    clearChargePointLogs: () =>
      dispatch(ChargePointActions.clearChargePointLogs()),
    clearChargePointTransactions: () =>
      dispatch(ChargePointActions.clearChargePointTransactions()),
    updateChargePoint: (index, chargePointData, onComplete) =>
      dispatch(
        ChargePointActions.updateChargePoint(
          index,
          chargePointData,
          onComplete,
        ),
      ),
    deleteChargePoint: (chargePointId) =>
      dispatch(ChargePointActions.deleteChargePoint(chargePointId)),
    fetchStationMoveList: (filter, offset) =>
      dispatch(StationActions.fetchStationMoveList(filter, offset)),
    fetchChargePointLogList: (filter, offset, chargePointId, ascendingLogs) =>
      dispatch(
        ChargePointActions.fetchChargePointLogList(
          filter,
          offset,
          chargePointId,
          ascendingLogs,
        ),
      ),
    fetchChargePointTransactionList: (
      filter,
      offset,
      chargePointId,
      ascendingTransactions,
    ) =>
      dispatch(
        ChargePointActions.fetchChargePointTransactionList(
          filter,
          offset,
          chargePointId,
          ascendingTransactions,
        ),
      ),
    fetchChargePointConfigList: (chargePointId) =>
      dispatch(ChargePointActions.fetchChargePointConfigList(chargePointId)),
    setChargePointLogPaginationOffset: (offset) =>
      dispatch(ChargePointActions.setChargePointLogPaginationOffset(offset)),
    setChargePointTransactionPaginationOffset: (offset) =>
      dispatch(
        ChargePointActions.setChargePointTransactionPaginationOffset(offset),
      ),
    editChargePoints: (selectedIndex, chargePoint) =>
      dispatch(StationActions.editChargePoints(selectedIndex, chargePoint)),
    clearMoveStations: () => dispatch(StationActions.clearMoveStations()),
    setMoveStationPaginationOffset: (offset) =>
      dispatch(StationActions.setMoveStationPaginationOffset(offset)),
    activateChargePoint: (index) =>
      dispatch(StationActions.activateChargePoint(index)),
    resetChargePointState: () =>
      dispatch(ChargePointActions.resetChargePointState()),
    clearChargePoints: () => dispatch(ChargePointActions.clearChargePoints()),
    resetFilters: () => dispatch(ChargePointActions.resetFilters()),
    fetchChargePoint: (chargePointId) =>
      dispatch(ChargePointActions.fetchChargePoint(chargePointId)),
    fetchChargePointList: (stationId) =>
      dispatch(ChargePointActions.fetchChargePointList(stationId)),
    setIsChargePointLogsLive: (flag) =>
      dispatch(ChargePointActions.setIsChargePointLogsLive(flag)),
    fetchChargePointUptimeStatistics: (
      chargePointId,
      chargePointStatisticsFilter,
    ) =>
      dispatch(
        ChargePointActions.fetchChargePointUptimeStatistics(
          chargePointId,
          chargePointStatisticsFilter,
        ),
      ),
    setChargePointStatisticsFilter: (newFilter) =>
      dispatch(ChargePointActions.setChargePointStatisticsFilter(newFilter)),
    fetchConnectorsUtilization: (chargePointId, chargePointStatisticsFilter) =>
      dispatch(
        ChargePointActions.fetchConnectorsUtilization(
          chargePointId,
          chargePointStatisticsFilter,
        ),
      ),
    fetchChargePointSubscribedAlerts: (chargePointId) =>
      dispatch(
        ChargePointActions.fetchChargePointSubscribedAlerts(chargePointId),
      ),
    fetchChargePointAlerts: (chargePointId) =>
      dispatch(ChargePointActions.fetchChargePointAlerts(chargePointId)),
    fetchChargePointLocalList: (chargePointId) =>
      dispatch(ChargePointActions.fetchChargePointLocalList(chargePointId)),
    fetchChargePointCompositeSchedule: (
      chargePointId,
      connectorId,
      duration,
      chargingRateUnitType,
    ) =>
      dispatch(
        ChargePointActions.fetchChargePointCompositeSchedule(
          chargePointId,
          connectorId,
          duration,
          chargingRateUnitType,
        ),
      ),
    fetchConnectorTypes: () =>
      dispatch(ChargePointActions.fetchConnectorTypes()),
    fetchOperatorUserActionsChargePoint: (chargePointId, filter, offset) =>
      dispatch(
        OperatorUserActionsAction.fetchOperatorUserActionsChargePoint(
          chargePointId,
          filter,
          offset,
        ),
      ),
    resetOperatorUserActionsChargePoint: () =>
      dispatch(OperatorUserActionsAction.resetOperatorUserActionsChargePoint()),
    setOperatorUserActionsPaginationOffset: (offset) =>
      dispatch(
        OperatorUserActionsAction.setOperatorUserActionsPaginationOffset(
          offset,
        ),
      ),
    setOperatorUserActionsFilters: (newFilter) =>
      dispatch(
        OperatorUserActionsAction.setOperatorUserActionsFilters(newFilter),
      ),
    setOperatorUserActionsFilters: (newFilter) =>
      dispatch(
        OperatorUserActionsAction.setOperatorUserActionsFilters(newFilter),
      ),
    clearOperatorUserActionsFilters: () =>
      dispatch(OperatorUserActionsAction.clearOperatorUserActionsFilters()),
    blockChargePoint: (chargePointId) =>
      dispatch(ChargePointActions.blockChargePoint(chargePointId)),
  }
}

const mapStateToProps = (state) => ({
  chargePoint: ChargePointSelectors.getSelectedChargePoint(state),
  maxPower: ChargePointSelectors.getFastestConnector(state),
  chargePointLogFilter: ChargePointSelectors.getChargePointLogFilter(state),
  chargePointLogs: ChargePointSelectors.getChargePointLogs(state),
  chargePointTransactionFilter:
    ChargePointSelectors.getChargePointTransactionFilter(state),
  chargePointTransactions:
    ChargePointSelectors.getChargePointTransactions(state),
  fetchChargePointLogListRequestState:
    ChargePointSelectors.getFetchChargePointLogListRequestState(state),
  fetchChargePointTransactionListRequestState:
    ChargePointSelectors.getFetchChargePointTransactionListRequestState(state),
  updateChargePointRequestState:
    ChargePointSelectors.getUpdateChargePointRequestState(state),
  selectedIndex: ChargePointSelectors.getSelectedIndex(state),
  deleteChargePointRequestState:
    ChargePointSelectors.getDeleteChargePointRequestState(state),
  fetchChargePointListRequestState:
    ChargePointSelectors.getFetchChargePointListRequestState(state),
  fetchChargePointRequestState:
    ChargePointSelectors.getFetchChargePointRequestState(state),
  resetChargePointRequestState:
    ChargePointSelectors.getResetChargePointRequestState(state),
  moveStationsFilter: StationSelectors.getMoveStationsFilter(state),
  fetchStationListRequestState:
    StationSelectors.getFetchStationListRequestState(state),
  moveChargePointRequestState:
    ChargePointSelectors.getMoveChargePointRequestState(state),
  stationSelectedIndex: StationSelectors.getSelectedIndex(state),
  selectedStation: StationSelectors.getSelectedStation(state),
  stationPaginationOffset: StationSelectors.getPaginationOffset(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
  operator: AuthSelectors.getOperator(state),
  chargePointName: ChargePointSelectors.getChargePointName(state),
  chargePointConnectors: ChargePointSelectors.getChargePointConnectors(state),
  clearChargePointCacheRequestState:
    ChargePointSelectors.getClearChargePointCacheRequestState(state),
  chargePoints: ChargePointSelectors.getChargePoints(state),
  changeChargePointAvailabilityRequestState:
    ChargePointSelectors.getChangeChargePointAvailabilityRequestState(state),
  deleteChargePointTariffsRequestState:
    ChargePointSelectors.getDeleteChargePointTariffsRequestState(state),
  addChargePointTariffsRequestState:
    ChargePointSelectors.getAddChargePointTariffsRequestState(state),
  addChargePointAccessGroupsBulkRequestState:
    ChargePointSelectors.getAddChargePointAccessGroupsBulkRequestState(state),
  deleteChargePointAccessGroupsBulkRequestState:
    ChargePointSelectors.getDeleteChargePointAccessGroupsBulkRequestState(
      state,
    ),
  deleteChargePointPrivacyRulesRequestState:
    ChargePointSelectors.getDeleteChargePointPrivacyRulesRequestState(state),
  addChargePointPrivacyRulesRequestState:
    ChargePointSelectors.getAddChargePointPrivacyRulesRequestState(state),
  chargePointUid: ChargePointSelectors.getChargePointUid(state),
  isChargePointLogsLive: ChargePointSelectors.getIsChargePointLogsLive(state),
  chargePointPrivacy: ChargePointSelectors.getChargePointPrivacy(state),
  chargePointAppVisibility:
    ChargePointSelectors.getChargePointAppVisibility(state),
  chargePointUptimeData:
    ChargePointSelectors.getChargePointUptimeStatistics(state),
  fetchChargePointUptimeStatisticsRequestState:
    ChargePointSelectors.getFetchChargePointUptimeStatisticsRequestState(state),
  chargePointStatisticsFilter:
    ChargePointSelectors.getChargePointStatisticsFilter(state),
  connectorsUtilizationData:
    ChargePointSelectors.getConnectorsUtilization(state),
  fetchConnectorsUtilizationRequestState:
    ChargePointSelectors.getFetchConnectorsUtilizationRequestState(state),
  operatorUserActionsFilters:
    OperatorUserActionsSelectors.getOperatorUserActionsFilters(state),
  fetchOperatorUserActionsChargePointRequestState:
    OperatorUserActionsSelectors.getFetchOperatorUserActionsChargePointRequestState(
      state,
    ),
  operatorUserActionsChargePoint:
    OperatorUserActionsSelectors.getOperatorUserActionsChargePoint(state),
})

ChargePointDetails.propTypes = {
  chargePoint: PropTypes.object,
  maxPower: PropTypes.number,
  chargePointLogFilter: PropTypes.arrayOf(PropTypes.object),
  chargePointTransactionFilter: PropTypes.arrayOf(PropTypes.object),
  setChargePointLogsFilter: PropTypes.func,
  setChargePointTransactionsFilter: PropTypes.func,
  clearChargePointLogs: PropTypes.func,
  clearChargePointTransactions: PropTypes.func,
  updateChargePoint: PropTypes.func,
  updateChargePointRequestState: PropTypes.number,
  selectedIndex: PropTypes.number,
  deleteChargePoint: PropTypes.func,
  deleteChargePointRequestState: PropTypes.number,
  fetchChargePointListRequestState: PropTypes.number,
  fetchChargePointRequestState: PropTypes.number,
  fetchChargePointLogList: PropTypes.func,
  fetchChargePointTransactionList: PropTypes.func,
  moveStationsFilter: PropTypes.arrayOf(PropTypes.object),
  fetchStationListRequestState: PropTypes.number,
  editChargePoints: PropTypes.func,
  setMoveStationPaginationOffset: PropTypes.func,
  operatorUser: PropTypes.object,
  operator: PropTypes.object,
  clearChargePointCacheRequestState: PropTypes.number,
  chargePointUid: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChargePointDetails)
